import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { Colors } from '../../constants/colors.constants';

import { ExpandMore } from '@mui/icons-material';

import { FC } from 'react';

type AccordionItemType = {
	title: string;
	description: string;
	id: string;
};

type AccordionListProps = { items: AccordionItemType[] };

export const AccordionList: FC<AccordionListProps> = ({ items }) => {
	const summaryStyles = {
		flexDirection: 'row-reverse',
		px: '24px',

		'& .MuiAccordionSummary-expandIconWrapper': {
			color: 'white',
		},
		'& .MuiAccordionSummary-content': {
			marginLeft: '10px',
		},
	};

	const summaryTitleStyles = {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: '600',
		lineHeight: '21px',
	};

	const descriptionStyles = {
		color: 'white',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: '400',
		lineHeight: '17px',
	};

	const accordionStyles = {
		borderRadius: '8px !important',
		background: Colors.white_a5,
		color: 'white',

		'&::before': {
			display: 'none',
		},
	};

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
			{items.map(({ title, description, id }) => (
				<Accordion key={id} disableGutters sx={accordionStyles}>
					<AccordionSummary expandIcon={<ExpandMore />} sx={summaryStyles}>
						<Typography component="span" sx={summaryTitleStyles}>
							{title}
						</Typography>
					</AccordionSummary>
					<AccordionDetails sx={{ padding: '0px 24px 14px' }}>
						<Typography sx={descriptionStyles}>{description}</Typography>
					</AccordionDetails>
				</Accordion>
			))}
		</Box>
	);
};
